export default "__VITE_ASSET__3940cfd2__"